// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Calendar from "./pages/Calendar";
import Services from "./pages/Services";
import About from "./pages/About";
import Jobs from "./pages/Jobs";
import Live from "./pages/Live";
import MentionsLegales from "./pages/MentionsLegales";
import Ranking from "./pages/Ranking";
import Exploring from "./pages/Exploring";
import Protocole from "./pages/Protocole";
import ConnectChrono from "./pages/ConnectChrono";
import Timeserver from "./pages/Timeserver";
import Livetiming from "./pages/Livetiming";
import StartlistPage from "./pages/StartlistPage";
import Config from "./pages/Config";
import Login from "./pages/Login";
import LiveOverview from "./pages/LiveOverview";
import SpeakerView from "./pages/SpeakerView";
import Bibs from "./pages/Bibs";
import Brackets from "./pages/Brackets";
import AthletesImportPage from "./pages/AthletesImportPage";
import QualificationsImportPage from "./pages/QualificationsImportPage";
import ParallelHub from "./pages/ParallelHub";
import ParallelArchives from "./pages/ParallelArchives";
import ParallelConfig from "./pages/ParallelConfig";
import ParallelFisExport from "./pages/ParallelFisExport";
import ParallelLive from "./pages/ParallelLive";
import StreamStartList from "./pages/stream/StreamStartList";
import StreamDuel from "./pages/stream/StreamDuel";
import StreamRanking from "./pages/stream/StreamRanking";
import SaisiePenaliteHub from "./pages/SaisiePenaliteHub";
import SaisiePenaliteOverview from "./pages/SaisiePenaliteOverview";
import SaisiePenalite from "./pages/SaisiePenalite";
import SaisiePenaliteSolo from "./pages/SaisiePenaliteSolo";
import TelemarkResults from "./pages/TelemarkResults";
import TimingSoftwareHub from "./components/timingsoftware/TimingSoftwareHub";
import TimingAthletesImport from "./components/timingsoftware/TimingAthletesImport";
import TimingStartList from "./components/timingsoftware/TimingStartList";
import TimingAthletesList from "./components/timingsoftware/TimingAthletesList";
import TimingChronoPage from "./components/timingsoftware/TimingChronoPage";
import TimingSwissSkiExport from "./components/timingsoftware/TimingSwissSkiExport";
import TimingFisPanel from "./components/timingsoftware/TimingFisPanel";
import Simulateur4Canaux from "./pages/Simulateur4Canaux";
import ResultsManager from "./components/ResultsManager";
import EventsManager from "./components/EventsManager";
import RoutesIndex from "./pages/RoutesIndex";
import TimingRaceExport from "./components/timingsoftware/TimingRaceExport";
import TeamCheckPage from "./components/timingsoftware/TeamCheckPage";
import TeamCheckTop from "./components/timingsoftware/TeamCheckTop";

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>

                <Routes>

                    {/* Pages normales avec Navbar + Footer */}
                    <Route
                        path="/"
                        element={
                            <>
                                <Navbar />
                                <Home />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/calendrier"
                        element={
                            <>
                                <Navbar />
                                <Calendar />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/prestations"
                        element={
                            <>
                                <Navbar />
                                <Services />
                                <Footer />
                            </>
                        }
                    />
                    <Route
                        path="/jobs"
                        element={
                            <>
                                <Navbar />
                                <Jobs />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/a-propos"
                        element={
                            <>
                                <Navbar />
                                <About />
                                <Footer />
                            </>
                        }
                    />
                    <Route path="/team-check/:eventKey" element={<TeamCheckPage />} />
                    <Route path="/team-check/:eventKey/top" element={<TeamCheckTop />} />

                    <Route
                        path="/mentions-legales"
                        element={
                            <>
                                <Navbar />
                                <MentionsLegales />
                                <Footer />
                            </>
                        }
                    />

                    {/* Connexion — page publique */}
                    <Route path="/login" element={<Login />} />

                    {/* Rôle "manuel" ET "chronométreur" (chronométreur voit tout) */}
                    <Route
                        path="/protocole"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur", "manuel"]}>
                                <>
                                    <Navbar />
                                    <Protocole />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/simulator"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur", "manuel"]}>
                                <>
                                    <Navbar />
                                    <Simulateur4Canaux />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />

                    {/* Rôle "chronométreur" uniquement */}
                    <Route
                        path="/timer"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ConnectChrono />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timeserver"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <Timeserver />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/live-overview"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <LiveOverview />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/documents"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ResultsManager />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/calendrier-admin"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <EventsManager />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/routes"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <RoutesIndex />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />

                    {/* Pages publiques (live, résultats, startlist) */}
                    <Route path="/live/:codex" element={<Livetiming />} />
                    <Route path="/live/:codex/startlist" element={<StartlistPage />} />
                    <Route path="/live/:codex/speaker" element={<SpeakerView />} />

                    {/* Courses parallèles — vues publiques live/speaker (pas de connexion) */}
                    <Route path="/parallel-live/:category" element={<ParallelLive />} />
                    <Route
                        path="/parallel-live/:category/speaker"
                        element={<ParallelLive speakerMode />}
                    />

                    {/* Overlays stream (OBS) — courses parallèles, fond transparent.
                        Volontairement PUBLIQUES (une source navigateur OBS n'envoie ni
                        cookie ni jeton) et SANS Navbar/Footer (casserait la transparence
                        et ajouterait des éléments de site indésirables sur le stream).
                        Course choisie via ?category=... dans l'URL (voir StreamControls). */}
                    <Route path="/stream/startlist" element={<StreamStartList />} />
                    <Route path="/stream/duel" element={<StreamDuel />} />
                    <Route path="/stream/ranking" element={<StreamRanking />} />

                    {/* Saisie mobile des pénalités de qualification télémark
                        (style + jump) par le scribe — pas de Navbar/Footer,
                        écran de téléphone. */}
                    <Route
                        path="/saisiepenalite/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["scribe", "chronometreur"]}>
                                <SaisiePenaliteHub />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/saisiepenalite/:eventKey/solo"
                        element={
                            <ProtectedRoute allowedRoles={["scribe", "chronometreur"]}>
                                <SaisiePenaliteSolo />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/saisiepenalite/:eventKey/overview"
                        element={
                            <ProtectedRoute allowedRoles={["scribe", "chronometreur"]}>
                                <SaisiePenaliteOverview />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/saisiepenalite/:eventKey/:category/:parity/:slot"
                        element={
                            <ProtectedRoute allowedRoles={["scribe", "chronometreur"]}>
                                <SaisiePenalite />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/resultats-telemark/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["scribe", "chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TelemarkResults />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />

                    {/* Timing Software — chronométrage de qualifications (module en construction) */}
                    <Route
                        path="/timingsoftware"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingSoftwareHub />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/athletes-import/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingAthletesImport />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/startlist/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingStartList />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/athletes/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingAthletesList />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/chrono/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingChronoPage />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/swissski/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingRaceExport/>
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/timingsoftware/fis/:eventKey"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <TimingFisPanel />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />

                    {/* Courses parallèles (brackets) */}
                    <Route
                        path="/bibs/:category"
                        element={
                            <ProtectedRoute allowedRoles={["colour", "chronometreur"]}>
                                <>
                                    <Navbar />
                                    <Bibs />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/brackets/:category"
                        element={
                            <ProtectedRoute allowedRoles={["paralleltimer", "chronometreur"]}>
                                <>
                                    <Navbar />
                                    <Brackets />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/athletes-import/:category"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <AthletesImportPage />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/qualifications-import/:category"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <QualificationsImportPage />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/parallel"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur", "colour", "paralleltimer"]}>
                                <>
                                    <Navbar />
                                    <ParallelHub />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/parallel-archives"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ParallelArchives />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/parallel-config"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ParallelConfig />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/parallel-config/:category"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ParallelConfig />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/parallel-fis/:category"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <>
                                    <Navbar />
                                    <ParallelFisExport />
                                    <Footer />
                                </>
                            </ProtectedRoute>
                        }
                    />

                    {/* Config d'un évènement — rôle "chronométreur" uniquement */}
                    <Route
                        path="/live/:codex/config"
                        element={
                            <ProtectedRoute allowedRoles={["chronometreur"]}>
                                <Config />
                            </ProtectedRoute>
                        }
                    />

                </Routes>

            </BrowserRouter>
        </ThemeProvider>
    );
}